// extracted by extract-css-chunks-webpack-plugin
module.exports = {"banner":"banner___GTFAu","banner-inner":"banner-inner___apGml","submit":"submit___Oa8jC","text":"text___PDHi0"};